import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=77fd48fe"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fd48fe')) {
      api.createRecord('77fd48fe', component.options)
    } else {
      api.reload('77fd48fe', component.options)
    }
    module.hot.accept("./Teacher.vue?vue&type=template&id=77fd48fe", function () {
      api.rerender('77fd48fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/Teacher.vue"
export default component.exports